<!--
 * @Author: lishiqiao
 * @Date: 2022-03-07 17:29:15
 * @LastEditors: lishiqiao
 * @LastEditTime: 2023-09-15 11:12:43
-->
<template>
  <div class="page-list">
    <!-- 搜索栏 -->
    <div class="page-search-content" ref="searchBox">
      <div class="page-big-box">
        <div class="page-search-item">
          <label>养殖场&nbsp;:</label>
          <el-select v-model="params.params.baseId" filterable placeholder="请选择养殖场">
            <el-option label="全部养殖场" value=""></el-option>
            <el-option v-for="item in baseList" :key="item.baseId" :label="item.baseName" :value="item.baseId">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>区域&nbsp;:</label>
          <el-select v-model="params.params.groupId" filterable placeholder="请选择区域">
            <el-option label="全部区域" value=""></el-option>
            <el-option v-for="item in groupList" :key="item.groupId" :label="item.groupName" :value="item.groupId">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>批次&nbsp;:</label>
          <el-select v-model="params.params.seedlingDataId" filterable placeholder="请选择批次">
            <el-option label="全部批次" value=""></el-option>
            <el-option v-for="item in batchList" :key="item.seedling_data_id" :label="item.seedling_data_name"
              :value="item.seedling_data_id">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>品类&nbsp;:</label>
          <el-select v-model="params.params.breedTypeId" filterable placeholder="请选择品类">
            <el-option label="全部品类" value=""></el-option>
            <el-option v-for="item in breedTypeList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="page-search-item">
          <label>品种&nbsp;:</label>
          <el-select v-model="params.params.breedId" filterable placeholder="请选择品种">
            <el-option label="全部品种" value=""></el-option>
            <el-option v-for="item in breedList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <!-- 选择日期年月日 -->
        <div class="page-search-date">
          <div class="page-search-item date-selection-box">
            <span @click="params.params.type = 'Y'" :class="[params.params.type == 'Y' ? 'active-date' : '']">年</span>
            <span @click="params.params.type = 'M'" :class="[params.params.type == 'M' ? 'active-date' : '']">月</span>
            <span @click="params.params.type = 'D'" :class="[params.params.type == 'D' ? 'active-date' : '']">日</span>
          </div>
          <div class="page-search-item" v-show="params.params.type === 'Y'">
            <label>年份&nbsp;:</label>
            <el-date-picker value-format="yyyy" v-model="params.params.year" :picker-options="pickerOptions" type="year"
              placeholder="请选择年份">
            </el-date-picker>
          </div>
          <div class="page-search-item" v-show="params.params.type === 'M'">
            <label>月份区间&nbsp;:</label>
            <el-date-picker v-model="monthRange" :picker-options="pickerOptions" value-format="yyyy-MM"
              @change="monthChange" type="monthrange" range-separator="~" start-placeholder="开始月份" end-placeholder="结束月份">
              >
            </el-date-picker>
          </div>
          <div class="page-search-item" v-show="params.params.type === 'D'">
            <label>日期区间&nbsp;:</label>
            <el-date-picker v-model="dateRange" :picker-options="pickerOptions" value-format="yyyy-MM-dd"
              @change="dateChange" type="daterange" range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </div>
      </div>
      <div class="page-search-btn">
        <div class="search-btn" @click="search">查询</div>
        <div class="reset-btn" @click="reset">重置</div>
        <div class="search-close-btn">
          <div @click="PageSearchClose" v-if="PageDisplay">
            <span>收起</span><i class="iconfont icon-a-List-Expand"></i>
          </div>
          <div @click="PageSearchOn" v-else>
            <span>展开</span><i class="iconfont icon-List-Collapse"></i>
          </div>
        </div>
      </div>
    </div>
    <!-- 内容 -->
    <div class="page-list-content">
      <!-- 列表 -->
      <div class="page-list-title">
        <!-- 年报表 -->
        <div v-if="params.params.type == 'Y'">
          <i class="title-icon"></i>育苗塘口收获情况年汇总表
        </div>
        <!-- 月报表 -->
        <div v-if="params.params.type == 'M'">
          <i class="title-icon"></i>育苗塘口收获情况月汇总表
        </div>
        <!-- 日报表 -->
        <div v-if="params.params.type == 'D'">
          <i class="title-icon"></i>育苗塘口收获情况日汇总表
        </div>
        <div>单位 : {{ unitName }}</div>
        <!-- 年报表 -->
        <div v-if="params.params.type == 'Y'">年份 : {{ showYear }}年</div>
        <!-- 月报表 -->
        <div v-if="params.params.type == 'M'">
          月份 :
          {{ showStartDate }}-{{ showEndDate }}
        </div>
        <!-- 日报表 -->
        <div v-if="params.params.type == 'D'">
          日期 :
          {{ showStartDate }}-{{ showEndDate }}
        </div>
        <div>
          <el-dropdown style="margin-right: 30px;" @command="setFixedColumn">
            <span class="el-dropdown-link">
              冻结列<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="y">冻结至"{{
                fixedColumn.label
              }}"列</el-dropdown-item>
              <el-dropdown-item command="n">取消冻结</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span @click="exportTable">
            <i class="title-export-btn iconfont icon-a-List-Export"></i>导出报表
          </span>
        </div>
      </div>
      <!-- 表格 -->
      <el-table :data="tableData" :max-height="tableHeight" border style="width: 100%" :row-class-name="tableRowClassName"
        @header-click="handleClick">
        <el-table-column :fixed="fixedColumnList[0].fixed" :class-name="fixedColumnList[0].selected ? 'cellSelected' : ''"
          prop="baseName" label="养殖场"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[1].fixed" :class-name="fixedColumnList[1].selected ? 'cellSelected' : ''"
          prop="groupName" label="区域"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[2].fixed" :class-name="fixedColumnList[2].selected ? 'cellSelected' : ''"
          prop="seedlingDataName" label="育苗批次">
        </el-table-column>
        <el-table-column :fixed="fixedColumnList[3].fixed" :class-name="fixedColumnList[3].selected ? 'cellSelected' : ''"
          prop="breedTypeName" label="品类"> </el-table-column>
        <el-table-column :fixed="fixedColumnList[4].fixed" :class-name="fixedColumnList[4].selected ? 'cellSelected' : ''"
          prop="breedName" label="育苗品种"> </el-table-column>
        <el-table-column prop="putBoxNum" label="投卵塘口数"> </el-table-column>
        <el-table-column prop="breedingBoxNum" label="养殖塘口数">
        </el-table-column>
        <el-table-column prop="harvestBoxNum" label="已收获塘口数">
        </el-table-column>
        <el-table-column prop="notHarvestBoxNum" label="未收获塘口数">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import service from "./ym-harvest-service";
import Page from "@/utils/methods/page";
export default {
  name: "harvest-pond",
  data() {
    return {
      monthRange: [],
      dateRange: [],
      PageDisplay: true,
      unitName: "", // 单位名称
      showYear: "", // 显示的年份
      showStartDate: "", // 显示的开始日期
      showEndDate: "", // 显示的结束日期
      tableHeight: 0, // 表格高度
      fixedColumn: {},
      fixedColumnList: [
        {
          prop: "baseName",
          fixed: false,
          selected: false
        },
        {
          prop: "groupName",
          fixed: false,
          selected: false
        },
        {
          prop: "seedlingDataName",
          fixed: false,
          selected: false
        },
        {
          prop: "breedTypeName",
          fixed: false,
          selected: false
        },
        {
          prop: "breedName",
          fixed: false,
          selected: false
        },
      ],
      // 分页参数
      params: {
        currPage: 1,
        pageSize: 13,
        orderBy: "desc",
        orderByName: "group_name",
        params: {
          orgId: "",
          groupId: "",
          baseId: "",
          breedTypeId: "",
          periodId: "",
          seedlingDataId: "",
          breedId: "",
          year: localStorage.getItem("m-year") ? localStorage.getItem("m-year") : this.$moment().year().toString(),
          startDate: "",
          endDate: "",
          type: "Y",
          breedTypeClass: "egg",
          // searchType: "org",
        },
      },
      exportParams: {}, // 导出参数
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6; //如果没有后面的-8.64e6就是不可以选择今天的
        },
      },
      tableData: [],
      baseList: [], // 养殖场列表
      groupList: [], // 区域列表
      batchList: [], // 批次列表
      breedTypeList: [], // 品类列表
      breedList: [], // 品种列表
    };
  },
  created() {
    this.tableHeight = window.innerHeight - 400;
    this.params.params.orgId = localStorage.getItem("orgId");
    // 获取养殖场列表
    this.getBaseList({
      orgId: this.params.params.orgId,
      breedTypeClass: "egg",
    });
    this.getGroupList({
      orgId: this.params.params.orgId,
      breedTypeClass: "egg",
    }); // 获取区域列表
    this.getBatchList({
      orgId: this.params.params.orgId,
      searchType: "org",
      breedTypeClass: "egg",
    }); // 获取批次列表
    this.getBreedTypeList({
      orgId: this.params.params.orgId,
      searchType: "org",
      breedTypeClass: "egg",
    }); // 获取品类列表
    this.getBreedList({
      orgId: this.params.params.orgId,
      searchType: "org",
      breedTypeClass: "egg",
    }); // 获取品种列表
    this.getPageList(); // 获取分页
  },
  mounted() {
    Page.pagesTableFixed(); // 表头固定
  },
  methods: {
    // 选择月
    monthChange(val) {
      if (!val) {
        return;
      }
      this.params.params.startDate = val[0];
      this.params.params.endDate = val[1];
    },

    // 选择日期
    dateChange(val) {
      if (!val) {
        return;
      }
      this.params.params.startDate = val[0];
      this.params.params.endDate = val[1];
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-08 15:50:33
     * @description: 塘口收获-养殖场下拉
     * @param {*} params
     */
    getBaseList(params) {
      service
        .getPondBaseList(params)
        .then((res) => {
          if (res.code == "0000") {
            this.baseList = res.data;
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-08 11:18:40
     * @description: 获取区域下拉
     * @param {*} params
     */
    getGroupList(params) {
      service
        .getPondGroupListNew(params)
        .then((res) => {
          if (res.code == "0000") {
            this.groupList = res.data;
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-08 11:38:02
     * @description: 获取批次下拉列表
     * @param {*} params
     */
    getBatchList(params) {
      service
        .getPondBatchList(params)
        .then((res) => {
          if (res.code == "0000") {
            this.batchList = res.data;
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-08 11:38:45
     * @description: 获取品类下拉列表
     * @param {*} params
     */
    getBreedTypeList(params) {
      service
        .getPondBreedTypeList(params)
        .then((res) => {
          if (res.code == "0000") {
            this.breedTypeList = res.data;
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-08 11:39:44
     * @description: 获取品种下拉列表
     * @param {*} params
     */
    getBreedList(params) {
      service
        .getPondBreedList(params)
        .then((res) => {
          if (res.code == "0000") {
            this.breedList = res.data;
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    // 查询
    search() {
      this.getPageList();
    },

    // 初始化时间
    initTime() {
      this.params.params.year = null;
      this.params.params.startDate = null;
      this.params.params.endDate = null;
      this.monthRange = [];
      this.dateRange = [];
      if (this.params.params.type == "Y") {
        this.params.params.year = localStorage.getItem("m-year") ? localStorage.getItem("m-year") : this.$moment().year().toString();
      }
      if (this.params.params.type == "M") {
        this.params.params.startDate = this.$moment().format("YYYY-MM");
        this.params.params.endDate = this.$moment().format("YYYY-MM");
        this.monthRange.push(this.params.params.startDate);
        this.monthRange.push(this.params.params.endDate);
      }
      if (this.params.params.type == "D") {
        this.params.params.startDate = this.$moment().format("YYYY-MM-DD");
        this.params.params.endDate = this.$moment().format("YYYY-MM-DD");
        this.dateRange.push(this.params.params.startDate);
        this.dateRange.push(this.params.params.endDate);
      }
    },

    // 重置
    reset() {
      this.params.params.baseId = "";
      this.params.params.groupId = "";
      this.params.params.seedlingDataId = "";
      this.params.params.breedTypeId = "";
      this.params.params.breedId = "";
      this.initTime();
      this.getPageList();
    },

    // 收起
    PageSearchClose() {
      Page.PageSearchClose(this);
    },

    // 展开
    PageSearchOn() {
      Page.PageSearchOn(this);
    },

    // 合计行高亮class赋予
    tableRowClassName({ row, rowIndex }) {
      if (row.baseName === "合计") {
        return "heji-row";
      }
    },

    // 显示的单位-年-月-日
    showListData() {
      if (this.params.params.year) {
        this.showYear = this.params.params.year;
      }
      if (this.params.params.baseId) {
        this.unitName = this.baseList.filter(
          (item) => item.baseId == this.params.params.baseId
        )[0].baseName;
      } else {
        const orgName = localStorage.getItem("orgName");
        this.unitName = orgName;
      }
      if (this.params.params.type == "M") {
        this.showStartDate = this.$moment(this.params.params.startDate).format(
          "YYYY年MM月"
        );
        this.showEndDate = this.$moment(this.params.params.endDate).format(
          "YYYY年MM月"
        );
      }
      if (this.params.params.type == "D") {
        this.showStartDate = this.$moment(this.params.params.startDate).format(
          "YYYY年MM月DD日"
        );
        this.showEndDate = this.$moment(this.params.params.endDate).format(
          "YYYY年MM月DD日"
        );
      }
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-03-08 11:40:56
     * @description: 获取收获概览-塘口收获-分页
     * @param {*}
     */
    getPageList() {
      const loading = this.$loading({
        lock: true,
        text: "数据加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      service
        .getPondPageList(this.params)
        .then((res) => {
          if (res.code == "0000") {
            this.tableData = res.data.list;
            this.showListData();
            this.exportParams = JSON.parse(JSON.stringify(this.params.params));
          }
          loading.close();
        })
        .catch((err) => {
          this.$message.error(err);
          loading.close();
        });
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-10 15:49:07
     * @description:导出
     * @param {*}
     */
    exportTable() {
      this.$confirm(`导出表格为excel文件，请确认！`, "操作提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.exportParams.fileName = "月桌面育苗投放概览塘口收获情况";
          service
            .exportPondData(this.exportParams)
            .then((res) => { })
            .catch((err) => {
              this.$message.error(err);
            });
        })
        .catch((err) => { });
    },

    // 选中列
    handleClick(column, event) {
      this.fixedColumnList.forEach((item, i) => {
        if (JSON.stringify(this.fixedColumnList).includes(column.property)) {
          if (item.prop === column.property) {
            item.selected = !item.selected;
            if (item.selected) {
              this.fixedColumn = column;
              this.fixedColumn.idx = i;
            } else {
              this.fixedColumn = {};
            }
          } else {
            item.selected = false;
          }
        }
      });
    },

    // 设置冻结列
    setFixedColumn(command) {
      if (command === 'y') {
        if (JSON.stringify(this.fixedColumn) === "{}") {
          this.$message('请选择列');
          return;
        }
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.fixedColumnList.forEach((item, i) => {
          if (i <= this.fixedColumn.idx) {
            item.fixed = true;
          }
        })
        this.$message('已冻结至"' + this.fixedColumn.label + '"列');
        this.fixedColumn = {};
      } else if (command === 'n') {
        this.fixedColumnList.forEach(item => {
          item.fixed = false;
          item.selected = false;
        })
        this.$message('已取消冻结');
      }
    }
  },
  watch: {
    // 监听type年月日变化
    "params.params.type"(val) {
      this.initTime();
      this.getPageList();
    },
  },
};
</script>

<style></style>